"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("recompose");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/prop-types */
/**
 * Higher Order Component factory which accepts an array of `interactions`
 * and returns an HOC. `interactions` may either be a Plottable Interaction class
 * instance or a function which accepts a `getProps()` function and returns a Plottable
 * Interaction class instance.
 *
 * The ladder case is for when an Plottable Interaction callback should invoke a callback
 * (i.e. onHover) which is supplied through props. (We use `getProps` rather than `props`
 * so that we can maintain access to latest props from inside the `getProps` closure).
 *
 * See: http://plottablejs.org/tutorials/interactions/
 */
var withPlottableInteractions = function withPlottableInteractions() {
  var interactions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (InnerComponent) {
    var _WrappedComponent;
    return _WrappedComponent = /*#__PURE__*/function (_React$Component) {
      (0, _inherits2["default"])(WrappedComponent, _React$Component);
      function WrappedComponent(props) {
        var _this;
        (0, _classCallCheck2["default"])(this, WrappedComponent);
        _this = _callSuper(this, WrappedComponent, [props]);
        _this.getProps = _this.getProps.bind((0, _assertThisInitialized2["default"])(_this));
        _this.handlePlotDetach = _this.handlePlotDetach.bind((0, _assertThisInitialized2["default"])(_this));
        _this.handlePlotAnchor = _this.handlePlotAnchor.bind((0, _assertThisInitialized2["default"])(_this));
        return _this;
      }
      (0, _createClass2["default"])(WrappedComponent, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          var _this2 = this;
          var plot = this.props.plot;
          this.interactions = interactions.map(function (interaction) {
            return typeof interaction === 'function' ? interaction(_this2.getProps) : interaction;
          });
          if (plot) {
            plot.onDetach(this.handlePlotDetach);
            plot.onAnchor(this.handlePlotAnchor);
          }
        }

        // eslint-disable-next-line camelcase
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          var plot = this.props.plot;
          if (plot !== nextProps.plot) {
            if (plot) {
              this.interactions.forEach(function (interaction) {
                return interaction.detachFrom(plot);
              });
              plot.offDetach(this.handlePlotDetach);
              plot.offAnchor(this.handlePlotAnchor);
            }
            if (nextProps.plot) {
              nextProps.plot.onDetach(this.handlePlotDetach);
              nextProps.plot.onAnchor(this.handlePlotAnchor);
            }
          }
        }

        /**
         * Useful so that we can access props without having to create recreate
         * interaction objects.
         */
      }, {
        key: "getProps",
        value: function getProps() {
          return this.props;
        }

        /**
         *
         * These are necessary because the Plottable interactions never register any detach callbacks to remove their
         * event listeners from the DOM. See https://github.com/palantir/plottable/issues/3277
         */
      }, {
        key: "handlePlotAnchor",
        value: function handlePlotAnchor(plot) {
          this.interactions.forEach(function (interaction) {
            return interaction.attachTo(plot);
          });
        }
      }, {
        key: "handlePlotDetach",
        value: function handlePlotDetach(plot) {
          this.interactions.forEach(function (interaction) {
            return interaction.detachFrom(plot);
          } /* enabled(false)*/);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/_react["default"].createElement(InnerComponent, this.props);
        }
      }]);
      return WrappedComponent;
    }(_react["default"].Component), (0, _defineProperty2["default"])(_WrappedComponent, "displayName", "withInteractions".concat((0, _recompose.getDisplayName)(InnerComponent))), _WrappedComponent;
  };
};
var _default = exports["default"] = withPlottableInteractions;
//# sourceMappingURL=withPlottableInteractions.js.map